export const API_URL = process.env.REACT_APP_API_URL || '/api/v1';
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || (API_URL.startsWith('http') ? (API_URL.includes('/api/v1') ? API_URL.split('/api/v1')[0] : API_URL) : '');
export const RAG_API_URL = process.env.REACT_APP_RAG_API_URL || `${API_URL}/nrag`;